import { render, staticRenderFns } from "./conlunmModel.vue?vue&type=template&id=608aa38d&scoped=true"
import script from "./conlunmModel.vue?vue&type=script&lang=js"
export * from "./conlunmModel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "608aa38d",
  null
  
)

export default component.exports